module.exports = __webpack_public_path__ + "static/github-2-99c0904c47aad4647174cbfadf0c1a65.mp4";